import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { ApiResponse } from '../types/recent-work';

export const getRecentWork = withLogger(async () => {
  const { data } = await authServiceAxiosClient.get<ApiResponse>(
    '/settings/recent-work',
  );

  return data.data ?? [];
});
